import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import axios from "axios";
import moment from "moment";
import { splitTeacherCourses } from "@/utils/teacherCourseSeparator";
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      studentId: "",
      // 校区列表
      campusList: JSON.parse(sessionStorage.getItem("campusList")),
      selectedCampusId: 0,
      campusNames: {},
      // 班级列表
      classList: [],
      oriClassList: [],
      classNames: {},
      classFee: {},
      selectedClassId: 0,
      selectedClassIds: [],
      selectedClassIndexs: [],
      todayDate: "",
      // 搜索班级
      searchStr: "",
      // 班级详细课程和价格
      // classId: course: teacherId: {courseFee: 200, courseMinutes: 111, realFee: 100}
      classCourseTeacherMinutesAndFee: {},
      // 每个班级的排课
      classArrangedCourse: {},
      // 报名班级，选择学生
      showSelectStudent: false,
      studentList: [],
      oriStudentList: [],
      studentNames: {},
      selectedStudentId: "",
      selectedStudentIndex: 0,
      searchStudentStr: "",
      // 可供选择的建议列表,所有学生名
      suggestions: [],
      // 根据输入过滤后的建议列表
      filteredSuggestions: [],
      showEditStudent: false,
      // 添加学生
      showAddStudent: false,
      studentName: "",
      studentGrade: "",
      studentSchool: "",
      studentPhone: "",
      studentParentPhone: "",
      phoneValidate: false,
      studentSource: "",
      teacherList: [],
      teacherNames: [],
      // 报名
      showEnrollPage: false,
      showModifyEnrollDateTimeRange: false,
      enrollDateTimeRange: [],
      totalFee: 0,
      realFee: 0,
      selectedDateTimeRange: [],
      // default-time 必须是 Date 对象数组
      defaultTime: [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)],
      // 单个 datetime 选择器默认时间：00:00:00
      defaultDateTime: new Date(2000, 1, 1, 0, 0, 0),
      paymentRemark: "",
      // 缴费
      showPayMethod: false,
      showPaySuccess: false,
      // 默认选择余额
      payMethod: "余额",
      // 默认选择余额
      selectUseBalancePay: true,
      balanceRemainPayMethod: "现金",
      studentBalance: 0,
      // 顾问列表
      consultantList: [],
      selectedConsultantIndex: "",
      tipResolver: null,
      showTip: false,
      tipMessage: "",
      tipNeedInput: false,
      tipInputText: "",
      showAddPaymentConsultant: false,
      paymentConsultantForm: {
        name: "",
        phone: ""
      }
    };
  },
  async mounted() {
    // 获取路由中的参数
    this.studentId = parseInt(this.$route.query.studentId);
    // console.log("this.studentId:", this.studentId);

    this.todayDate = moment().format("YYYY-MM-DD");
    if (!this.campusList) {
      await this.queryCampus();
    }
    if (this.campusList.length > 0) {
      this.selectedCampusId = this.campusList[0].campus.id;
    }

    // 校区id转name
    for (let i = 0; i < this.campusList.length; i++) {
      this.campusNames[this.campusList[i].campus.id] = this.campusList[i].campus.name;
    }
    {
      const t0 = Date.now();
      await this.getClassList();
      console.log(`[enrollment] getClassList took ${Date.now() - t0}ms`);
    }

    // 筛选这个校区的班级
    this.handleCampusChange();
    {
      const t0 = Date.now();
      await this.getClassFee();
      console.log(`[enrollment] getClassFee took ${Date.now() - t0}ms`);
    }
    await this.getStudentList();
    await this.getTeacherList();
    await this.getConsultantList();
  },
  methods: {
    // 查询校区
    async queryCampus() {
      //loading界面
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/queryCampus", params);
        if (resp1.data.code == "0000") {
          console.log("获取校区:", resp1.data.data);
          this.campusList = resp1.data.data;
          sessionStorage.setItem("campusList", JSON.stringify(resp1.data.data));
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取学生列表
    async getStudentList() {
      //loading界面
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentList", params);
        if (resp1.data.code == "0000") {
          this.studentList = resp1.data.data;
          this.oriStudentList = JSON.parse(JSON.stringify(this.studentList));
          this.studentNames = this.studentList.reduce((studentNames, student) => {
            studentNames[String(student.id)] = student.name;
            return studentNames;
          }, {});
          this.suggestions = [];
          for (let i = 0; i < this.studentList.length; i++) {
            this.suggestions.push(this.studentList[i].name);
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    getClassStudentNames(classItem) {
      if (!classItem.studentIds || classItem.studentIds.length === 0) {
        return [];
      }
      return classItem.studentIds.map(studentId => {
        return this.studentNames[String(studentId)] || `未知学生（ID：${studentId}）`;
      });
    },
    // 获取顾问列表
    async getConsultantList() {
      //loading界面
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/getSalesPerson", params);
        if (resp1.data.code == "0000") {
          this.consultantList = resp1.data.data;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    addPaymentConsultant() {
      this.paymentConsultantForm = {
        name: "",
        phone: ""
      };
      this.showAddPaymentConsultant = true;
    },
    closeAddPaymentConsultant() {
      this.showAddPaymentConsultant = false;
    },
    async submitPaymentConsultant() {
      const consultantName = this.paymentConsultantForm.name.trim();
      const consultantPhone = this.paymentConsultantForm.phone.trim();
      if (!consultantName) {
        alert("请输入顾问姓名");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(consultantPhone)) {
        alert("请输入正确的11位手机号");
        return;
      }
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        const resp = await axios.post("https://backend.wonology.com/finance/consultantPerformance/addConsultant", {
          consultantName,
          consultantPhone,
          performanceTarget: {},
          institution: this.institution,
          isEdit: false
        });
        if (resp.data.code != "0000") {
          alert(resp.data.msg);
          return;
        }
        await this.getConsultantList();
        const consultantIndex = this.consultantList.findIndex(item => item.name === consultantName);
        if (consultantIndex >= 0) {
          this.selectedConsultantIndex = consultantIndex;
          this.handleConsultantChange();
        }
        this.showAddPaymentConsultant = false;
      } catch (error) {
        alert("添加顾问失败: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取班级列表
    async getClassList() {
      //loading界面
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassList", params);
        if (resp1.data.code == "0000") {
          this.classList = resp1.data.data;

          // 部分字段json.parse()
          for (let i in this.classList) {
            this.classList[i].teacherIds = JSON.parse(this.classList[i].teacherIds);
            this.classList[i].courses = JSON.parse(this.classList[i].courses);
            this.classList[i].periods = JSON.parse(this.classList[i].periods);
            if (!this.classList[i].studentIds) {
              this.classList[i].studentIds = [];
            } else {
              this.classList[i].studentIds = JSON.parse(this.classList[i].studentIds);
            }
          }
          this.oriClassList = JSON.parse(JSON.stringify(this.classList));

          // console.log("获取班级列表 this.classList:", this.classList);

          for (let i = 0; i < this.classList.length; i++) {
            this.classNames[this.classList[i].id] = this.classList[i].name;
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 获取班级有哪些科目，哪些老师，单价，课时
    async getClassFee(dateRange, classId) {
      //loading界面
      // const loading = this.$loadingDiv1({ text: "处理中..." });
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        // 如果不传日期范围，就是查从今天开始的课时，费用
        let params = {
          institution: this.institution,
          dateRange: dateRange,
          classId: classId
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/getClassFee", params);
        if (resp1.data.code == "0000") {
          this.classCourseTeacherMinutesAndFee = resp1.data.data;
          this.classArrangedCourse = resp1.data.classArrangedCourse;
          const missingFeeClasses = resp1.data.missingFeeClasses || {};

          // console.log(
          //   "获取班级有哪些科目，哪些老师，单价，课时:",
          //   this.classCourseTeacherMinutesAndFee
          // );

          // 计算每个班级的费用
          // this.classFee = {};
          for (let classId in this.classCourseTeacherMinutesAndFee) {
            this.classFee[classId] = {
              totalHours: 0,
              totalMinutes: 0,
              totalFee: 0,
              missingFeeMessages: missingFeeClasses[classId] || []
            };

            // 每个科目
            for (let course in this.classCourseTeacherMinutesAndFee[classId]) {
              // 每个老师
              for (let teacherId in this.classCourseTeacherMinutesAndFee[classId][course]) {
                this.classFee[classId].totalMinutes += this.classCourseTeacherMinutesAndFee[classId][course][teacherId].courseMinutes;
                this.classFee[classId].totalFee += this.classCourseTeacherMinutesAndFee[classId][course][teacherId].courseFee * this.classCourseTeacherMinutesAndFee[classId][course][teacherId].courseMinutes / 60;

                // 初始优惠单价为原单价
                this.classCourseTeacherMinutesAndFee[classId][course][teacherId].realFee = this.classCourseTeacherMinutesAndFee[classId][course][teacherId].courseFee;
              }
            }
            this.classFee[classId].totalHours = parseFloat((this.classFee[classId].totalMinutes / 60).toFixed(2));
            this.classFee[classId].totalFee = parseFloat(this.classFee[classId].totalFee.toFixed(2));
          }
          const missingFeeMessages = [...new Set(Object.values(missingFeeClasses).flat())];
          if (missingFeeMessages.length > 0) {
            alert(missingFeeMessages.join("\n"));
          }
          // console.log("this.classFee:", this.classFee);

          return true;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert(resp1.data.msg);
          return false;
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    //获取老师列表(筛选出启用的)
    async getTeacherList() {
      //loading界面
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        let params = {
          institution: this.institution,
          flag: "onlyActive" //(筛选出启用的)
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/getTeacherList", params);
        if (resp1.data.code == "0000") {
          this.teacherList = resp1.data.data;
          for (let i in this.teacherList) {
            this.teacherList[i].courses = splitTeacherCourses(this.teacherList[i].coursesStr);
          }

          // console.log("获取老师列表 this.teacherList:", this.teacherList);

          this.teacherNames = {};
          for (let i = 0; i < this.teacherList.length; i++) {
            this.teacherNames[this.teacherList[i].id] = this.teacherList[i].name;
          }
          // console.log("this.teacherNames:", this.teacherNames);
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 获取学生 总缴费，总退费，剩余金额
    async getStudentBalance(studentId) {
      //loading界面
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        let params = {
          studentId: studentId
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentBalance", params);
        if (resp1.data.code == "0000") {
          this.studentBalance = resp1.data.data.balance;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 下拉框 弹框 宽度设置
    async setSelectWidth() {
      await this.$nextTick();

      // 下拉框 弹框 宽度设置
      let selectDropdownElement = document.querySelectorAll(".el-select-dropdown");
      console.log("selectDropdownElement:", selectDropdownElement);
      for (let element of selectDropdownElement) {
        // 取消下拉框 弹框 minWidth属性，使下拉框宽度自适应
        element.style.minWidth = "";

        // 设置下拉框 弹框 最大高度，超过滚动
        // element.style.maxHeight = "100px";
        element.style.overflowY = "auto";
      }
    },
    clickCampusSelect() {
      // 通过 this.$refs 获取 el-select 实例
      const select = this.$refs.campusSelectRef;
      if (select) {
        // 先聚焦（可选，但推荐）
        select.focus();
        // 调用 toggleMenu 展开/收起下拉菜单
        select.toggleMenu();
      }
    },
    // 选择校区
    handleCampusChange() {
      // 筛选这个校区的班级
      this.classList = this.oriClassList.filter(item => item.campusId == this.selectedCampusId);

      // 筛选还没结班的班级
      // this.classList = this.classList.filter(
      //   (item) => item.endDate >= this.todayDate
      // );
    },
    // 搜索班级
    search() {
      const formerClassList = this.classList;
      this.handleCampusChange();
      const filteredClassList = this.classList.filter(item => item.name.includes(this.searchStr));
      if (this.searchStr && filteredClassList.length == 0) {
        alert("没有搜到班级");
        this.classList = formerClassList;
        return;
      }
      this.classList = filteredClassList;
    },
    // 选择班级
    selectClass(classId) {
      this.selectedClassId = classId;
      this.selectedClassIds = [classId];
    },
    // 点击报名按钮
    async enroll() {
      this.selectedStudentId = "";
      this.studentName = "";
      this.studentGrade = "";
      this.studentSchool = "";
      this.studentPhone = "";
      this.studentSource = "";
      if (this.selectedClassIds.length == 0) {
        alert("请选择班级");
        return;
      }

      // if (this.studentList.length == 0) {
      //   alert("当前没学生，请先预存学生信息");

      //   return;
      // }

      // 不在报名详情外面判断，可能换报名时间段了
      // if (this.classFee[this.selectedClassIds[0]].totalFee == 0) {
      //   alert("班级课时为0，无法报名");

      //   return;
      // }

      // 班级的index
      this.selectedClassIndexs = [];
      for (let i in this.selectedClassIds) {
        this.selectedClassIndexs.push(this.classList.findIndex(item => item.id == this.selectedClassIds[i]));
      }
      if (this.selectedClassIndexs.some(classIndex => classIndex < 0) && Array.isArray(this.oriClassList)) {
        this.handleCampusChange();
        this.selectedClassIndexs = this.selectedClassIds.map(classId => this.classList.findIndex(item => item.id == classId));
      }
      if (this.selectedClassIndexs.some(classIndex => classIndex < 0)) {
        alert("没有搜到班级");
        return;
      }

      //重新查询课时和价格
      let result = await this.getClassFee(null, this.classList[this.selectedClassIndexs[0]].id);
      if (!result) {
        return;
      }

      // 如果是从学员管理报名跳过来，判断这个学生有没有已经报名这个班级
      if (this.studentId) {
        let studentIds = this.classList[this.selectedClassIndexs[0]].studentIds;

        // 选择这个学生
        this.selectedStudentId = this.studentId;
        this.selectedStudentIndex = this.studentList.findIndex(student => student.id === this.studentId);
        this.studentName = this.studentList[this.selectedStudentIndex].name;
        this.studentGrade = this.studentList[this.selectedStudentIndex].grade;
        this.studentSchool = this.studentList[this.selectedStudentIndex].school;
        this.studentPhone = this.studentList[this.selectedStudentIndex].phone;
        this.studentSource = this.studentList[this.selectedStudentIndex].customer_source;
        if (studentIds.includes(this.studentId)) {
          this.openModifyEnrollDateTimeRangeForStudent(this.studentId);
          return;
        }
      }

      // 不需要选择学生弹窗
      // this.showSelectStudent = true;

      // 选择学生下拉框展开的宽度
      // await this.$nextTick();
      // this.setSelectWidth();

      // 获取选择的班级的开班结班日期
      this.selectedDateTimeRange = [this.classList[this.selectedClassIndexs[0]].startDate + " 00:00:00", this.classList[this.selectedClassIndexs[0]].endDate + " 23:59:59"];
      // 如果今天已经过了开班日期，则将选择日期段设置为今天和结班日期
      if (this.todayDate >= this.classList[this.selectedClassIndexs[0]].startDate) {
        let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
        this.selectedDateTimeRange = [currentTime, this.classList[this.selectedClassIndexs[0]].endDate + " 23:59:59"];
      }
      // 如果今天已经过了结班日期，则将选择日期段设置为今天
      if (this.todayDate > this.classList[this.selectedClassIndexs[0]].endDate) {
        let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
        this.selectedDateTimeRange = [currentTime, currentTime];
      }
      this.calculateTotalRealFee();
      this.showEnrollPage = true;
    },
    openModifyEnrollDateTimeRangeForStudent(studentId) {
      let studentIndex = this.classList[this.selectedClassIndexs[0]].studentIds.indexOf(studentId);
      let studentDateRange = JSON.parse(this.classList[this.selectedClassIndexs[0]].studentDateRange || "[]");
      // 学生的报名日期范围
      this.enrollDateTimeRange = studentDateRange[studentIndex];

      // 修改报名时间范围弹窗
      this.showModifyEnrollDateTimeRange = true;
    },
    calculateTotalRealFee() {
      // 计算总价，和实收
      this.totalFee = 0;
      this.realFee = 0;
      for (let i in this.selectedClassIds) {
        this.totalFee += this.classFee[this.selectedClassIds[i]].totalFee;
      }
      for (let i in this.selectedClassIds) {
        let classId = this.selectedClassIds[i];
        for (let course in this.classCourseTeacherMinutesAndFee[classId]) {
          for (let teacherId in this.classCourseTeacherMinutesAndFee[classId][course]) {
            let hours = parseFloat((this.classCourseTeacherMinutesAndFee[classId][course][teacherId].courseMinutes / 60).toFixed(2));
            this.realFee += hours * this.classCourseTeacherMinutesAndFee[classId][course][teacherId].realFee;
          }
        }
      }
      this.totalFee = parseFloat(this.totalFee.toFixed(2));
      this.realFee = parseFloat(this.realFee.toFixed(2));
    },
    // 选择学生
    selectStudentConfirm() {
      if (this.selectedStudentId == "") {
        alert("请选择学生");
        return;
      }

      // 获取学生的index
      this.selectedStudentIndex = this.studentList.findIndex(item => item.id == this.selectedStudentId);
      this.showSelectStudent = false;

      // 计算总价，和实收
      this.totalFee = 0;
      this.realFee = 0;
      for (let i in this.selectedClassIds) {
        this.totalFee += this.classFee[this.selectedClassIds[i]].totalFee;
      }
      for (let i in this.selectedClassIds) {
        let classId = this.selectedClassIds[i];
        for (let course in this.classCourseTeacherMinutesAndFee[classId]) {
          for (let teacherId in this.classCourseTeacherMinutesAndFee[classId][course]) {
            let hours = parseFloat((this.classCourseTeacherMinutesAndFee[classId][course][teacherId].courseMinutes / 60).toFixed(2));
            this.realFee += hours * this.classCourseTeacherMinutesAndFee[classId][course][teacherId].realFee;
          }
        }
      }
      this.totalFee = parseFloat(this.totalFee.toFixed(2));
      this.realFee = parseFloat(this.realFee.toFixed(2));

      // 获取选择的班级的开班结班日期
      // this.selectedDateTimeRange = [
      //   this.classList[this.selectedClassIndexs[0]].startDate,
      //   this.classList[this.selectedClassIndexs[0]].endDate,
      // ];
      // // 如果今天已经过了开班日期，则将选择日期段设置为今天和结班日期
      // if (
      //   this.todayDate > this.classList[this.selectedClassIndexs[0]].startDate
      // ) {
      //   this.selectedDateTimeRange = [
      //     this.todayDate,
      //     this.classList[this.selectedClassIndexs[0]].endDate,
      //   ];
      // }

      this.showEnrollPage = true;
    },
    selectStudentCancel() {
      this.showSelectStudent = false;
    },
    // 报名详情页面
    // 选择日期段
    async selectDateRangeChange() {
      // 如果没有手动选择小时，结束时间的默认值是00:00:00，改为23:59:59
      // if (this.selectedDateTimeRange[1].split(" ")[1] == "00:00:00") {
      //   let date = this.selectedDateTimeRange[1].split(" ")[0];
      //   let time = "23:59:59";

      //   this.selectedDateTimeRange[1] = date + " " + time;
      // }

      console.log("this.selectedDateTimeRange:", this.selectedDateTimeRange);

      //重新查询课时和价格
      await this.getClassFee(this.selectedDateTimeRange, this.selectedClassId);
      this.calculateTotalRealFee();
    },
    // 限制只能输入浮点数，最多两位小数
    handleFloatInput(classId, course, teacherId, event) {
      let value;
      // console.log("typeof event:", typeof event);
      // @input传来的event是string类型，就是value
      if (typeof event == "string") {
        value = event;
      }
      // @blur传来的event是event对象
      else {
        value = event.target.value;
      }

      // console.log("handleFloatInput value:", value);
      // console.log("this.realFee:", this.realFee);
      // 允许空值
      if (value === "") {
        // 实收
        if (classId == "") {
          this.realFee = 0;
          this.realFeeChange();
        }
        // 优惠单价
        else {
          this.classCourseTeacherMinutesAndFee[classId][course][teacherId].realFee = 0;
          this.courseRealFeeChange();
        }
        return;
      }

      // 正则表达式匹配数字和最多两位小数
      const regex = /^\d*\.?\d{0,2}$/;

      // 如果符合格式则不处理
      if (regex.test(value)) {
        // 去除前导零，但保留一个小数点前的零（如 0.5 的情况）
        if (value.startsWith("0") && value.length > 1 && value.charAt(1) !== ".") {
          value = value.replace(/^0+/, "") || "0";
        }
      }
      // 不符合格式
      else {
        // 移除最后一个无效字符
        value = value.slice(0, -1);

        // value = this.formerValue

        // 去除前导零，但保留一个小数点前的零（如 0.5 的情况）
        // if (
        //   value.startsWith("0") &&
        //   value.length > 1 &&
        //   value.charAt(1) !== "."
        // ) {
        //   value = value.replace(/^0+/, "") || "0";
        // }
      }

      // 更新实收
      if (classId == "") {
        this.realFee = value;
        this.realFeeChange();
      }
      // 更新优惠价格
      else {
        this.classCourseTeacherMinutesAndFee[classId][course][teacherId].realFee = value;
        this.courseRealFeeChange();
      }
      console.log("this.realFee:", this.realFee);
    },
    // 修改优惠单价，重新计算实收
    courseRealFeeChange() {
      this.realFee = 0;
      for (let i in this.selectedClassIds) {
        let classId = this.selectedClassIds[i];
        for (let course in this.classCourseTeacherMinutesAndFee[classId]) {
          for (let teacherId in this.classCourseTeacherMinutesAndFee[classId][course]) {
            let hours = parseFloat((this.classCourseTeacherMinutesAndFee[classId][course][teacherId].courseMinutes / 60).toFixed(2));
            this.realFee += hours * this.classCourseTeacherMinutesAndFee[classId][course][teacherId].realFee;
          }
        }
      }
      this.realFee = parseFloat(this.realFee.toFixed(2));
    },
    // 修改实收，重新计算优惠单价
    realFeeChange() {
      let percent = this.realFee / this.totalFee;
      for (let i in this.selectedClassIds) {
        let classId = this.selectedClassIds[i];
        for (let course in this.classCourseTeacherMinutesAndFee[classId]) {
          for (let teacherId in this.classCourseTeacherMinutesAndFee[classId][course]) {
            this.classCourseTeacherMinutesAndFee[classId][course][teacherId].realFee = parseFloat((this.classCourseTeacherMinutesAndFee[classId][course][teacherId].courseFee * percent).toFixed(2));
          }
        }
      }
      let formerRealFee = this.realFee;

      // 每个优惠单价变了, 重新计算实收
      this.courseRealFeeChange();

      // 如果实收和手动输入的不一致，微调优惠单价（有些场景无法和手动输入一样，暂不做）
      if (formerRealFee - this.realFee > 0) {}
      if (formerRealFee - this.realFee < 0) {}
    },
    // 点击缴费，到选择缴费方式页面
    async enrollPay() {
      if (this.selectedStudentId == "") {
        alert("请选择学生");
        return;
      }
      if (this.classList[this.selectedClassIndexs[0]].studentIds.includes(this.selectedStudentId)) {
        this.openModifyEnrollDateTimeRangeForStudent(this.selectedStudentId);
        return;
      }

      // console.log(
      //   "this.classList[this.selectedClassIndexs[0]].courseType:",
      //   this.classList[this.selectedClassIndexs[0]].courseType
      // );

      // 如果是一对一班级，课时为0，可以报名
      if (this.classList[this.selectedClassIndexs[0]].courseType == "一对一") {
        // 如果是一对一，已经有学生，不能再报名
        if (this.classList[this.selectedClassIndexs[0]].studentIds && this.classList[this.selectedClassIndexs[0]].studentIds.length > 0) {
          alert("该一对一班级已经有学生了，无法报名");
          return;
        }
      }
      // 其他班级，课时为0，无法报名
      else {
        if (this.classFee[this.selectedClassIds[0]].totalFee == 0) {
          alert("班级课时为0，无法报名");
          return;
        }
      }
      await this.getStudentBalance(this.selectedStudentId);
      this.showPayMethod = true;
    },
    // 取消报名
    enrollCancel() {
      this.showEnrollPage = false;
    },
    payMethodChange() {
      if (this.payMethod == "余额") {
        this.selectUseBalancePay = true;
      } else {
        this.selectUseBalancePay = false;
        this.balanceRemainPayMethod = this.payMethod;
      }
    },
    // 点击支付方式的文字，也是选择
    clickPayMethodWord(payMethod) {
      // console.log("payMethod:", payMethod);
      this.payMethod = payMethod;
      this.payMethodChange();
    },
    // 选择缴费方式后，确认缴费
    async enrollPayConfirm() {
      // 缴费完成后，班级添加学生，价格
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        const isPartialBalancePay = this.selectUseBalancePay && Number(this.studentBalance) < Number(this.realFee);

        // 非余额支付，或余额不足需要补差额时，需要选择签约顾问
        if (!this.selectUseBalancePay || isPartialBalancePay) {
          if (this.selectedConsultantIndex === "") {
            alert("请选择签约顾问");
            return;
          }
        }

        // 只传报名的班级的排课信息
        let conciseClassArrangedCourse = {};
        let conciseClassCourseTeacherMinutesAndFee = {};
        for (let i = 0; i < this.selectedClassIds.length; i++) {
          let classId = this.selectedClassIds[i];
          conciseClassArrangedCourse[classId] = this.classArrangedCourse[classId];

          // 每节课，只保留课程的部分字段
          for (let i in conciseClassArrangedCourse[classId]) {
            let obj = conciseClassArrangedCourse[classId][i];
            conciseClassArrangedCourse[classId][i] = {
              id: obj.id,
              classId: obj.classId,
              teacherId: obj.teacherId,
              course: obj.course,
              date: obj.date,
              period: obj.period,
              feeGroupKey: obj.feeGroupKey
            };
          }
          conciseClassCourseTeacherMinutesAndFee[classId] = this.classCourseTeacherMinutesAndFee[classId];
        }
        let consultantId;
        // 如果全额使用余额支付，consultantId 为null
        if (this.selectUseBalancePay && !isPartialBalancePay) {
          consultantId = null;
        }
        // 不使用余额支付，或余额不足补差额，有签约顾问
        else {
          consultantId = this.consultantList[this.selectedConsultantIndex].id;
        }
        let params = {
          selectedClassIds: this.selectedClassIds,
          classCourseTeacherMinutesAndFee: conciseClassCourseTeacherMinutesAndFee,
          classArrangedCourse: conciseClassArrangedCourse,
          dateTimeRange: this.selectedDateTimeRange,
          studentId: this.selectedStudentId,
          consultantId: consultantId,
          realFee: this.realFee,
          selectUseBalancePay: this.selectUseBalancePay,
          payMethod: this.payMethod,
          balanceRemainPayMethod: this.balanceRemainPayMethod,
          paymentRemark: this.paymentRemark
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/studentEnrollClass", params);
        if (resp1.data.code == "0000") {
          this.showPayMethod = false;
          this.showPaySuccess = true;

          // 更新学生数
          if (this.classList[this.selectedClassIndexs[0]].studentIds) {
            this.classList[this.selectedClassIndexs[0]].studentIds.push(this.selectedStudentId);
          } else {
            this.classList[this.selectedClassIndexs[0]].studentIds = [this.selectedStudentId];
          }
        } else {
          console.log("调用studentEnrollClass出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("调用后端出错catch error:" + error);
        alert("调用后端出错: " + error);
      } finally {
        loading.close();
      }
    },
    enrollPayCancel() {
      this.showPayMethod = false;
    },
    enrollPaySuccessCancel() {
      this.showPaySuccess = false;
      this.showEnrollPage = false;
    },
    openDateTimeRangePicker_Start() {
      console.log("openDateTimeRangePicker_Start");
      const picker = this.$refs.datePicker_Start;
      // Element Plus 一般可用 focus 打开，某些版本用 click
      picker.focus();
    },
    openDateTimeRangePicker_End() {
      console.log("openDateTimeRangePicker_End");
      const picker = this.$refs.datePicker_End;
      // Element Plus 一般可用 focus 打开，某些版本用 click
      picker.focus();
    },
    async modifyEnrollDateTimeRangeConfirm() {
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        console.log("this.enrollDateTimeRange:", this.enrollDateTimeRange);
        let studentIndex = this.classList[this.selectedClassIndexs[0]].studentIds.indexOf(this.selectedStudentId);
        let studentDateRange = JSON.parse(this.classList[this.selectedClassIndexs[0]].studentDateRange);

        // 限制报名日期范围不能缩小
        let formerEnrollDateTimeRange = studentDateRange[studentIndex];
        if (formerEnrollDateTimeRange[0] < this.enrollDateTimeRange[0] || formerEnrollDateTimeRange[1] > this.enrollDateTimeRange[1]) {
          alert("报名日期范围不能缩小");
          return;
        }

        // 更新学生的报名日期范围
        studentDateRange[studentIndex] = this.enrollDateTimeRange;
        let params = {
          studentId: this.selectedStudentId,
          studentIndex: studentIndex,
          studentDateRange: studentDateRange,
          enrollDateTimeRange: this.enrollDateTimeRange,
          classId: this.classList[this.selectedClassIndexs[0]].id
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/modifyStudentEnrollDateTimeRange", params);
        if (resp1.data.code == "0000") {
          this.classList[this.selectedClassIndexs[0]].studentDateRange = JSON.stringify(studentDateRange);
          this.showModifyEnrollDateTimeRange = false;
          this.showEnrollPage = false;
          console.log("已修改报名时间范围");
          loading.close();

          // 提示弹窗，修改报名时间范围成功
          this.showTip = true;
          this.tipMessage = `已修改报名时间范围`;

          // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
          // 后面通过 this.tipResolver(value) 返回值
          const tipConfirmed = await new Promise(resolve => {
            this.tipResolver = resolve;
          });
          if (tipConfirmed === "confirm") {
            // 用户选择确认，继续执行

            this.showTip = false;
            // 重置变量
            this.tipMessage = "";
            this.tipNeedInput = false;
          } else {
            // 用户选择取消，返回

            return;
          }
        } else {
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    modifyEnrollDateTimeRangeCancel() {
      this.showModifyEnrollDateTimeRange = false;
    },
    // 提示弹窗 取消
    closeTip() {
      this.showTip = false;
      // 重置变量
      this.tipMessage = "";
      this.tipNeedInput = false;
      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("cancel");
        this.tipResolver = null;
      }
    },
    confirmTip() {
      // this.showTip = false;
      // // 重置变量
      // this.tipMessage = "";
      // this.tipNeedInput = false;

      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("confirm");
        this.tipResolver = null;
      }
    },
    // 添加学生
    addStudent() {
      this.showAddStudent = true;
    },
    async addStudentConfirm() {
      //loading界面
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        if (this.studentPhone || this.studentParentPhone) {} else {
          alert("学生或家长手机号至少填一个");
          return;
        }
        if (this.studentName && this.studentGrade && this.studentSchool && this.studentSource) {} else {
          alert("请填写完整信息");
          return;
        }
        let phoneValid = this.validatePhone(this.studentPhone);
        if (!phoneValid) {
          // alert("请输入正确的手机号");

          return;
        }
        phoneValid = this.validatePhone(this.studentParentPhone);
        if (!phoneValid) {
          // alert("请输入正确的手机号");

          return;
        }
        let params = {
          name: this.studentName,
          grade: this.studentGrade,
          school: this.studentSchool,
          phone: this.studentPhone,
          parentPhone: this.studentParentPhone,
          source: this.studentSource,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/addStudent", params);
        if (resp1.data.code == "0000") {
          this.showAddStudent = false;
          await this.getStudentList();

          // 添加学生后，自动选这个学生
          this.selectedStudentIndex = this.oriStudentList.findIndex(item => item.name === this.studentName);
          this.selectedStudentId = this.oriStudentList[this.selectedStudentIndex].id;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    addStudentCancel() {
      this.showAddStudent = false;
    },
    // 校验手机号
    validatePhone(phone) {
      if (!phone) {
        phone = this.studentPhone;
      }

      // 如果是空，不判断
      if (!phone) {
        phone = this.studentPhone;
        return true;
      }

      // 手机号正则表达式 (11位数字，以1开头, 第二个必须是3-9，剩下9个数字)
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!mobileRegex.test(phone)) {
        this.phoneValidate = false;
        alert("请输入正确的手机号");
        return false;
      }
      this.phoneValidate = true;
      return true;
    },
    // 修改学生信息
    editStudent() {
      this.showEditStudent = true;
    },
    async editStudentConfirm() {
      //loading界面
      const loading = this.$loadingDiv1({
        text: "处理中..."
      });
      try {
        if (this.studentPhone || this.studentParentPhone) {} else {
          alert("学生或家长手机号至少填一个");
          return;
        }
        if (this.studentName && this.studentGrade && this.studentSchool && this.studentSource) {} else {
          alert("请填写完整信息");
          return;
        }
        let phoneValid = this.validatePhone(this.studentPhone);
        if (!phoneValid) {
          // alert("请输入正确的手机号");

          return;
        }
        phoneValid = this.validatePhone(this.studentParentPhone);
        if (!phoneValid) {
          // alert("请输入正确的手机号");

          return;
        }
        let params = {
          studentId: this.selectedStudentId,
          name: this.studentName,
          grade: this.studentGrade,
          school: this.studentSchool,
          phone: this.studentPhone,
          parentPhone: this.studentParentPhone,
          source: this.studentSource,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/editStudent", params);
        if (resp1.data.code == "0000") {
          this.showEditStudent = false;
          await this.getStudentList();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    editStudentCancel() {
      this.showEditStudent = false;

      // 恢复到修改前的信息
      this.studentName = this.oriStudentList[this.selectedStudentIndex].name;
      this.studentGrade = this.oriStudentList[this.selectedStudentIndex].grade;
      this.studentSchool = this.oriStudentList[this.selectedStudentIndex].school;
      this.studentPhone = this.oriStudentList[this.selectedStudentIndex].phone;
      this.studentParentPhone = this.oriStudentList[this.selectedStudentIndex].parentPhone;
      this.studentSource = this.oriStudentList[this.selectedStudentIndex].customer_source;
    },
    searchStudent() {
      //输入内容时 生成匹配的选项
      // 如果搜索内容为空，返回空
      if (this.searchStudentStr.trim() === "") {
        this.filteredSuggestions = [];
      }
      // 如果有搜索内容，返回筛选的选项
      else {
        this.filteredSuggestions = this.suggestions.filter(item => item.toLowerCase().includes(this.searchStudentStr.toLowerCase()));
      }
    },
    // 当选择建议项时，赋值
    selectSuggestion(suggestion) {
      this.selectedStudentId = this.oriStudentList.find(item => item.name === suggestion).id;
      this.selectedStudentIndex = this.oriStudentList.findIndex(item => item.name === suggestion);

      // 赋值
      this.studentName = suggestion;
      this.studentGrade = this.oriStudentList[this.selectedStudentIndex].grade;
      this.studentSchool = this.oriStudentList[this.selectedStudentIndex].school;
      this.studentPhone = this.oriStudentList[this.selectedStudentIndex].phone;
      this.studentParentPhone = this.oriStudentList[this.selectedStudentIndex].parentPhone;
      this.studentSource = this.oriStudentList[this.selectedStudentIndex].customer_source;

      // 赋值后，清空搜索框
      this.searchStudentStr = "";
      this.filteredSuggestions = [];
    },
    closeSuggestions() {
      // 延时关闭建议列表，确保点击事件先被处理
      setTimeout(() => {
        this.filteredSuggestions = [];
      }, 200);
    },
    handleConsultantChange() {}
  }
};